import React from 'react';
import { useInView } from 'react-intersection-observer';

export default function LazyMedia({
    type,
    src,
    alt = '',
    critical = false,
    resolutions = [320, 640, 1024, 1280, 1920],
    ...props
}) {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    // Détecter si l'URL est une URL présignée AWS (avec signature)
    const isPresignedUrl = src.includes("X-Amz-Signature");

    // Fonction pour générer srcset uniquement si l'URL n'est pas présignée
    const generateSrcSet = (src, resolutions) => {
        if (isPresignedUrl) return ""; // Désactive srcset pour les URLs présignées
        const extension = src.split('.').pop();
        return resolutions
            .map(res => `${src.replace(`.${extension}`, `-${res}.${extension}`)} ${res}w`)
            .join(', ');
    };

    // Chargement immédiat si critical = true
    if (critical) {
        return (
            <picture>
                {!isPresignedUrl && (
                    <source
                        srcSet={generateSrcSet(src, resolutions)}
                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    />
                )}
                <img
                    src={src}
                    alt={alt}
                    loading="eager"
                    {...props}
                />
            </picture>
        );
    }

    // Chargement différé pour les éléments non critiques
    return (
        <div ref={ref} style={{ minHeight: type === 'image' ? '200px' : '400px' }}>
            {inView ? (
                <picture>
                    {!isPresignedUrl && (
                        <source
                            srcSet={generateSrcSet(src, resolutions)}
                            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                        />
                    )}
                    <img
                        src={src}
                        alt={alt}
                        loading="lazy"
                        {...props}
                    />
                </picture>
            ) : (
                <div className="image-placeholder">Chargement...</div>
            )}
        </div>
    );
}
